import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiOauthService, MareAuthService } from '@mare-common/ngx-mare-auth';
import { ErrorHandlerService, EventInteractionService } from '@mare-common/ngx-mare-common';
@Injectable({
  providedIn: 'root'
})
export class PlatformApiOauthService extends ApiOauthService {

  constructor(
    public override http: HttpClient,
    public override errorHandler: ErrorHandlerService,
    public override sanitizer: DomSanitizer,
    public override authService: MareAuthService,
    public override eventInteractionService: EventInteractionService

  ) {
    super(http, errorHandler, sanitizer, authService, eventInteractionService);
    console.log('PlatformApiOauthService');
  }


  // override setHeaders(): Promise<HttpHeaders> {
  //   return new Promise(async (resolve, reject) => {
  //     const token = await this.authService.retrieveToken().then((response) => {
  //       return response;
  //     }, (error) => {
  //       console.log(error);
  //       reject(error);
  //      }
  //     );

  //     if(token === undefined || token === null || (""+token).trim() === "") {
  //       reject("no token");
  //     }

  //     const headers: HttpHeaders = new HttpHeaders()
  //     .set('Content-Type', 'application/json')
  //     .set('Authorization', `Bearer ${token}`);
  //     resolve(headers);
  //   });
    
  // }

  // override setFileHeaders(): Promise<HttpHeaders> {
  //   return new Promise((resolve) => {


  //     const token: string | undefined = this.authService.getAccessToken();
  //     const headers: HttpHeaders = new HttpHeaders()
  //     .set('Authorization', `Bearer ${token}`);
  //     resolve(headers);
  //   });
  // }



//   override buildUrl(url: string, endpoint: string) {
//     if (url.endsWith("/") && endpoint.startsWith('/')) {
//       endpoint = endpoint.substring(1);
//     }
//     else {
//       if (!url.endsWith("/") && !endpoint.startsWith('/')) {
//         endpoint = "/" + endpoint;
//       }
//     }
//     url += endpoint;
//     return url;
//   }

}
